const PhonesPage = () => {
  return null;
};

export default PhonesPage;
